<template>
  <div class="wrap">
    <img src="~common/image/buy-vip-bg.jpg" alt="" class="bg">
    <!-- 返回首页 -->
    <router-link class="back-home" tag="div" to="/">
      <img src="~common/image/vip-back.png" alt="" class="">
      <div>返回课堂</div>
    </router-link>
    <div class="notice-wrap">
      <div class="notice">
        <div :style="{top:-frame*24+'px'}" :class="{animate:animate}">
          <p v-for="(item,index) in data" :key="index">恭喜{{item}}成功升级为golo会员</p>
        </div>
      </div>
    </div>
    <div class="all">
      <span class="line"></span>
      <span class="t">已有{{vips}}位汽修学员开通</span>
      <span class="line"></span>
      <div class="list">
        <div v-for="(item,i) in list" :key="i" :class="{hide:index !== i }" @click="setI(i)">
          <!-- 没有首冲字段 或者 是首冲 的样式-->
          <template v-if="typeof item.is_first === 'undefined' || item.is_first">
            <div class="interval">{{item.spec}}</div>
            <div class="price-wrap">
              <s>原价：{{Number(item.original_price)}}</s>
              <div>{{Number(item.price)}}元</div>
              <p v-if="item.discount">限时{{Number(item.discount)}}折</p>
              <p v-else>&nbsp;</p>
            </div>
            <div class="light">&nbsp;{{item.goods_desc}}</div>
          </template>
          <template v-else>
            <!-- 非首冲 并且 这个是针对首冲的 -->
            <div class="interval">{{item.spec}}</div>
            <div class="price-wrap">
              <s>&nbsp;</s>
              <div>{{Number(item.price)}}元</div>
              <p>&nbsp;</p>
            </div>
            <div class="light">&nbsp;</div>
          </template>
        </div>
        <!--
        <div :class="{hide:index !== 1}" @click="setI(1)">
          <div class="interval">1年</div>
          <div class="price-wrap">
            <s>原价：359</s>
            <div>249元</div>
            <p>限时7折</p>
          </div>
          <div class="light">推荐</div>
        </div>
        <div :class="{hide:index !== 2}" @click="setI(2)">
          <div class="interval">2年</div>
          <div class="price-wrap">
            <s>原价：359</s>
            <div>249元</div>
            <p>限时7折</p>
          </div>
          <div class="light">再送一年（超值）</div>
        </div>
        -->
      </div>
      <a :href="payurl" class="buy" v-if="list&&list.length>0">马上开通</a>
      <a href="javascript:;" class="buy disabled" v-else>马上开通</a>
      <div class="agree">支付即表示同意并接受此<router-link tag="a" href="javascript:;" to="/vip/agree">服务协议</router-link></div>
    </div>
  </div>
</template>

<script>
import {init} from '@/api/vip'
import {RES_OK} from '@/api/config'
import config from '@/utils/config.js'
export default {
  props: ['type'],
  data() {
    return {
      index: 1,
      height: 24, // 高度
      data: [],
      list: [],
      vips: '',
      frame: 0,
      animate: true,
      timer: null
    }
  },
  computed: {
    payurl() {
      let wxUrl = 'index/index/pay/?goods_type=member&'
      let h5Url = 'index/index/pay/?payment_platform=MWEB&goods_type=member&'
      let padUrl = 'index/index/qrpay/?goods_type=member&'
      // 获取设备类型
      // DEVICE_TYPE: wechat, h5, pad
      const DEVICE_TYPE = localStorage.getItem('device_type')
      const url = {
        wechat: wxUrl,
        h5: h5Url,
        pad: padUrl
      }[DEVICE_TYPE]
      let webDomain = localStorage.getItem('web_domain') || config.host
      console.log(webDomain + url + 'goods_id=' + (this.list[this.index] && this.list[this.index].course_id) + '&video_id=1&payment_type=1' + '&anchor=/personal')
      return (webDomain + url + 'goods_id=' + (this.list[this.index] && this.list[this.index].course_id) + '&video_id=1&payment_type=1' + '&anchor=/personal')
    }
  },
  created() {
    let entry
    if (this.type === 'zhuan') {
      entry = 2
    }
    init(entry).then(({data}) => {
      const result = data.data
      if (result && data.code === RES_OK) {
        // console.log(result)
        if (result.carousel_user) {
          // 设置vip滚动名单
          this.data = result.carousel_user
          this.timer = setInterval(() => {
            // console.log(this.frame)
            if (this.frame + 1 >= this.data.length) {
              this.animate = false
              this.frame = 0
            } else {
              this.animate = true
              this.frame++
            }
          }, 2000 + 600)
        }
        if (result.vip_list) {
          this.list = result.vip_list
          if (this.list.length < 3) {
            this.index = 0
          }
        }
        if (result.vip_count) {
          this.vips = result.vip_count
        }
      }
    })
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    setI(i) {
      this.index = i
    }
  }
}
</script>

<style scoped lang="stylus" ref="stylesheet/stylus">
  @import "~common/stylus/variable"
  .wrap
    background #19191b
    margin-bottom size(-120)
    position relative
  .bg
    display block
    width 100%
    height: 100%
  .back-home
    position absolute
    top size(34)
    left size(34)
    color #fff
    font-size size(26)
    font-weight 800
    text-align center
    z-index 9
    img
      width size(54)
      display block
      margin 0 auto size(10)
  .all
    color #eec783
    text-align center
    padding 0 size(40)
    position relative
    top size(-120)
    .line
      display inline-block
      width size(70)
      height 2px
      background #eec783
      vertical-align middle
      margin 0 4px
    .t
      font-size size(32)
      font-weight 800
    .list
      display flex
      justify-content: center
      margin-top size(50)
      margin-left -12px
      >div
        width 33.3%
        margin-left 12px
        min-height 30px
        border 1px solid #d3b365
        text-align center
        position relative
        &.hide
          &:after
            z-index 1
            content ' '
            display block
            position absolute
            left -1px
            top -1px
            bottom -1px
            right -1px
            background rgba(0,0,0,.5)
        &:nth-child(2)
          .light
            background #f27266
        &:nth-child(3)
          .light
            background #4d88ba
    .interval
      line-height size(56)
      background-color #caa756
      background linear-gradient(to right, #c9a656, #edd48d)
      color #fff
      font-size size(30)
    .price-wrap
      background #2e2e32
      line-height 1
      padding size(32) 0 size(26)
      s
        color #8a8a91
        font-size size(22)
      div
        font-size size(42)
        font-weight 800
        margin size(16) 0 size(12)
      p
        font-size size(26)
        color #8a8a91
    .light
      line-height size(40)
      font-size size(22)
      background #2e2e32
      color #fff
    .buy
      display block
      font-size size(32)
      color #19191b
      font-weight 800
      line-height size(88)
      background linear-gradient(to right, #c9a656, #edd48d)
      margin-top size(50)
      &.disabled
        opacity .5
  .agree
    font-size size(26)
    color #ffffff
    padding size(30) 0 size(56)
    a
      color #d3b365
      text-decoration underline
  .notice-wrap
    position absolute
    left 0
    top 0
    width 100%
    padding-top percentage(472/750)
  .notice
    width percentage(420/750)
    margin 0 auto
    line-height 24px
    height 24px
    border-radius 12px
    background #d2b062
    font-size size(26)
    color #19191b
    text-align center
    overflow hidden
    >div
      &.animate
        position relative
        transition top .6s ease-in-out
</style>



// WEBPACK FOOTER //
// src/components/personal/vip/buy-vip.vue